module.exports = __webpack_public_path__ + "img/1.8973d789.png";